import "./SuggestedResponse.scss";

import React from "react";
import { Tooltip } from "react-tippy";

import { ReactComponent as AIIcon } from "../../assets/icons/openai-icon.svg";
import { ReactComponent as ThumbsDownIcon } from "../../assets/icons/thumbs-down.svg";
import Button from "../Button";
import { ErrorMessageContainer } from "../ErrorMessageContainer";
import Loading from "../Loading";

const SuggestedResponse = ({
  thread,
  loading,
  error,
  openAIContextModal,
  handleThumbsDown,
  thumbsDownLoading,
  thumbsDownError,
  isSuggestedResponseUsed
}) => {
  const isGuestMessageLast = thread?.posts?.[0]?.is_guest;

  return (
    <div className="SuggestedResponse">
      <Tooltip
        html={
          <p className="tooltip">
            AI suggestions are only available if the last message is a guest
            message
          </p>
        }
        position="top"
        disabled={loading || isGuestMessageLast}
      >
        <Button
          type="button"
          onClick={openAIContextModal}
          title="Re-generate AI suggestion with additional context"
          className="SuggestedResponse__button"
          disabled={loading || !isGuestMessageLast}
        >
          <AIIcon className="SuggestedResponse__icon" />
          {loading && <Loading className="SuggestedResponse__loader" />}
        </Button>
      </Tooltip>
      {isSuggestedResponseUsed && (
        <Button
          type="button"
          onClick={handleThumbsDown}
          title="Mark the AI suggestion as not helpful"
          className="SuggestedResponse__button"
          disabled={thumbsDownLoading}
        >
          <ThumbsDownIcon className="SuggestedResponse__icon" />
          {thumbsDownLoading && (
            <Loading className="SuggestedResponse__loader" />
          )}
        </Button>
      )}

      {(error || thumbsDownError) && (
        <div className="SuggestedResponse__error">
          <ErrorMessageContainer>
            An error occurred, please try again later
          </ErrorMessageContainer>
        </div>
      )}
    </div>
  );
};

export default SuggestedResponse;
